import { type RubricCategory } from '../model'
import { isEmpty, isNotDefined } from './isEmpty'

export const getCategoryScore = (category: RubricCategory): { possible: number; score: number } => {
  return category.questions.reduce(
    (acc, question) => {
      return {
        possible: acc.possible + question.value,
        score: acc.score + (question.user?.score ?? question.ai?.score ?? 0),
      }
    },
    {
      possible: 0,
      score: 0,
    }
  )
}

export const getRubricScore = ({ rubric }: { rubric: RubricCategory[] }): { possible: number; score: number } => {
  return rubric.reduce(
    (acc, category) => {
      const categoryScore = getCategoryScore(category)
      return {
        possible: acc.possible + categoryScore.possible,
        score: acc.score + categoryScore.score,
      }
    },
    {
      possible: 0,
      score: 0,
    }
  )
}

export const getRubricScorePercentage = ({ rubric }: { rubric?: RubricCategory[] }): number | undefined => {
  if (isEmpty(rubric)) return
  const { possible, score } = getRubricScore({ rubric })
  if (possible === 0) return
  return Math.max(Math.min(score / possible, 1), 0)
}

// Whole percent from 0 to 100, the scale the conversation index stores and filters on.
export const getRubricScorePercent = ({ rubric }: { rubric?: RubricCategory[] }): number | undefined => {
  const percentage = getRubricScorePercentage({ rubric })
  if (isNotDefined(percentage)) return
  return Math.round(percentage * 100)
}
